import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import useIsMobile from "utils/hooks/useIsMobile";

export default function DatePicker(props){
    const isMobile = useIsMobile()

    return(
        <DateTimePicker 
            format={props?.format || (isMobile ? "dd MMM yyyy" : "dd MMMM yyyy")}
            clearIcon={null}
            disableClock
            onChange={props?.onChange}
            value={props?.value} 
            className={props?.className}
            disabled={props?.disabled}
        />
    )
}